import { RadioGroup } from 'eone-ui/radio/radio';
import type { SCFormFieldProps } from './form_field';
import { SCFormField } from './form_field';
import { handleFieldUp } from './helper';
import { SCFormLabel } from '../form';

interface SCFormFieldRadioGroupProps extends SCFormFieldProps {
  Buttons: {
    Label: string;
    Value: string;
  }[];
  Value?: string;
  Disabled?: boolean;
  Alignment?: number;
  OnChange?: (value: string) => void;
}

const SCFormFieldRadioGroup = ({
  label,
  name,
  required,
  disabled,
  rules,
  Alignment = 2,
  ...rest
}: SCFormFieldRadioGroupProps) => {
  return (
    <SCFormField
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      rules={rules}
      withMarginBottom
    >
      {({ field }) => {
        return (
          <>
            {label && <SCFormLabel label={label} required={required} />}
            <RadioGroup
              {...handleFieldUp(field, { disabledRef: true })}
              Label={label}
              Required={required}
              ShowRequiredIndicator={required}
              Alignment={Alignment}
              {...rest}
            />
          </>
        );
      }}
    </SCFormField>
  );
};

export { SCFormFieldRadioGroup };
export type { SCFormFieldRadioGroupProps };
